<template>
  <div>
		<m-header class="y-center ptb-xs">
      <span class="size-md bolder">{{id?'编辑':'新增'}}党员诚信经营户申报</span>
    </m-header>
		<div class="edit_cell">
			<el-card class="box-card edit_left">
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="申报标题:">
						<el-input v-model="form.title"></el-input>
					</el-form-item>
					<el-form-item label="上传图片:">
						<m-uploader type="single" :file.sync="form.imgUrl"></m-uploader>
					</el-form-item>
					<el-form-item label="报名日期:">
						<el-date-picker
							v-model="form.registrationTime"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
          <el-form-item style="margin-top: 40px;">
						<el-button @click="cancel">取消</el-button>
						<el-button type="primary" @click="onSubmit">保存</el-button>
					</el-form-item>
				</el-form>
			</el-card>
		</div>
	</div>
</template>

<script>
import PartyMember from '@/axios/api/partyMember.js'
export default {
	data() {
		return {
			form: {
				title: '', //标题
				imgUrl: '', //图片
				registrationTime: '', //报名时间
			},
      id: null,
		}
	},
	created() {
    this.id = this.$route.query.id || null;
		if (this.id) {
			this.getData();
		}
	},
	methods: {
	setCurrentStepLocation() {
      this.form.address = this.location.name;
      this.form.latitude = this.location.latitude;
      this.form.longitude = this.location.longitude;
    },
		//
		async onSubmit() {
			let data = this.dealData()
			if (this.isValid(data)) {
				if(this.id) {
					data.id = this.id
					this.updateData(data);
				} else {
					
					let res = await PartyMember.postDeclare(data)
					if (res.status == 1) {
            this.$message.success('提交成功')
						this.$router.go(-1)
					}
					console.log(res);
				}
			}
			 
		},
		cancel() {
			//返回列表
			this.$router.go(-1)
		},
		//修改活动
		async updateData(data) {
			let res = await PartyMember.putDeclare(data)
			if(res.status == 1) {
        this.$message.success('提交成功')
				this.$router.go(-1)
			}
		},
		//获取详情
		async getData( ) {
			let res = await PartyMember.getDeclare(this.id)
			if (res.status == 1) {
				let data = res.data
				this.form.title = data.title
				this.form.imgUrl = data.imgUrl
				this.form.registrationTime = [data.startTime, data.endTime]
			}
		},

		fromateTime(d) {
			return new Date(d).getTime()
		},
		
		isValid(obj) {
      if (!obj.title) {
        this.$message.info("标题不能为空");
        return false;
      }
      if (!obj.imgUrl) {
        this.$message.info("封面不能为空");
        return false;
      }
			if (!obj.startTime) {
        this.$message.info("报名日期不能为空");
        return false;
      }
      return true;
    },

		dealData() {
			let data = {
				startTime : this.fromateTime(this.form.registrationTime[0]) ,
				endTime : this.fromateTime(this.form.registrationTime[1]),
				title: this.form.title, //标题
				imgUrl: this.form.imgUrl, //图片
			}
			return data
		}
	}

}
</script>

<style lang="less">
.box-card {
	// width: 68%;
	// margin-right: 2%;
	display: inline-block;
}

.edit_left {
	flex: 1;
	margin-right: 10px;
}

.right {
    width: 380px;
    height: 280px;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    margin-left: 10px;
}

.right .box-card {
  width: 100%;
}

.edit_cell {
	display: flex;
}
</style>
